import { parseAsString, useQueryState } from 'nuqs';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { getStatusParamValue } from '../utils/deploymentUtils';

export const useDeploymentNavigation = () => {
  const navigate = useNavigate();

  const [projectIdParam, setProjectParam] = useQueryState(
    'projectId',
    parseAsString.withDefault('')
  );
  const [pipelineNameParam, setPipelineNameParam] = useQueryState(
    'search',
    parseAsString.withDefault('')
  );
  const [viewParam, setViewParam] = useQueryState(
    'view',
    parseAsString.withDefault('')
  );
  const [statusParam, setStatusParam] = useQueryState(
    'status',
    parseAsString.withDefault('')
  );
  const [refreshIntervalParam, setRefreshIntervalParam] = useQueryState(
    'refreshInterval',
    parseAsString.withDefault('5')
  );

  const changeEnvironment = useCallback(
    (environment: string) => {
      const statusTag = getStatusParamValue(statusParam);
      const query = new URLSearchParams({
        projectId: projectIdParam,
        status: statusTag,
        pipelineName: pipelineNameParam,
        refresh: refreshIntervalParam,
        view: viewParam
      }).toString();

      const currentPath = window.location.pathname;
      const pathParts = currentPath.split('/');
      const realmIndex = pathParts.findIndex(part => part === 'operation');
      if (realmIndex > 0) {
        const activeRealm = pathParts[realmIndex - 1];
        navigate(
          `/${encodeURIComponent(activeRealm)}/operation/run/${encodeURIComponent(environment)}?${query}`,
          {
            replace: true
          }
        );
      }
    },
    [
      statusParam,
      projectIdParam,
      pipelineNameParam,
      refreshIntervalParam,
      viewParam,
      navigate
    ]
  );

  const changeUrl = useCallback(
    (obj: {
      pipelineName?: string;
      projectId?: string;
      refresh?: string;
      view?: string;
      status?: string | string[];
    }) => {
      setPipelineNameParam(obj.pipelineName || null);
      setProjectParam(obj.projectId || null);
      setRefreshIntervalParam(obj.refresh || '5');
      setViewParam(obj.view || null);
      if (obj.status) {
        const statusValue = Array.isArray(obj.status)
          ? obj.status.join(',')
          : obj.status;
        setStatusParam(statusValue);
      }
    },
    [
      setPipelineNameParam,
      setProjectParam,
      setStatusParam,
      setRefreshIntervalParam,
      setViewParam
    ]
  );

  const changeObjSearch = useCallback(
    (obj: { search: { projectId?: string } }) => {
      setProjectParam(obj.search.projectId || null);
    },
    [setProjectParam]
  );

  return {
    viewParam,
    projectIdParam,

    setProjectParam,
    setViewParam,

    changeEnvironment,
    changeUrl,
    changeObjSearch
  };
};
